import React from 'react';
import { PerlmanGreen, Strong } from '../../theme';

export const SuggestionBox = () => (
    <div style={{
        padding: '16px 16px 1px 16px',
        backgroundColor: 'white',
        marginTop: -4,
        borderBottomRightRadius: 4,
        borderBottomLeftRadius: 4,
        boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.25)',
    }}
    >
        <Strong style={{ color: PerlmanGreen }}>
            Not finding an exact match?
        </Strong>
        <p style={{ marginTop: 8, color: 'rgba(0, 0, 0, 0.87)' }}>
            That’s ok! Try picking one with the brand name in it (e.g. for Aetna Choice POS choose Aetna).
        </p>
    </div>
);
